/*
* 2024-12-14 Paul N. add sticky add to cart customization
* "sticky add to cart section" Modified by Paul N., Modifications: Additional logic for configuration of subfeatures, styles, and javascript behaviors is licensed under CC BY-SA 4.0
* / A derivative from the original work by Rafael & pete https://stackoverflow.com/questions/75556864/how-do-i-make-my-add-to-cart-button-sticky-on-shopify/75578742#75578742
*/
customElements.define('sticky-product-form', class StickyProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.debug = false;
    this.productForm = document.querySelector('product-form');
    this.productStickyForm = document.querySelector('.product--sticky-form');
    this.variantIdElement = this.productStickyForm.querySelector('input[name="id"]');
    this.priceElement = this.productStickyForm.querySelector('.price-item--regular');

    this.productFormBounds = {};
    this.boundingClientRectTop;
    /*this.intersectionObserverOptions = {
      root: document.querySelector("product-form"),
      rootMargin: "0px",
      threshold: 0,
    };*/

    this.variantOnSaleElement = this.productStickyForm.querySelector('.price--on-sale .price__sale');
    if (this.variantOnSaleElement) {
      this.PriceCompareElement = this.variantOnSaleElement.querySelector('.price-item--regular');
      this.priceElement = this.productStickyForm.querySelector('.price-item--sale');
    }

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
    // this.handleVariantInputs();
    // window.addEventListener('variant-change', this.onVariantChangeHandler, false);
    this.variant;
    this.previousVariant;
    document.addEventListener('variant:change', function(event) {
      this.variant = event.detail.variant; // Gives you access to the whole variant details
      this.previousVariant = event.detail.previousVariant; // Gives you access to the details of the previously selected variant
      // form = event.target; // The form that triggers the change
    });

    this.createObserver();
    //this.observerCallbackHandler = this.observerCallback.bind(this);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  handleVariantChange(event) {
    let variant = this.getSelectedVariant(event.data.variantId);
    let formattedPrice = event.data.formattedPrice;
    let formattedCompareAtPrice = event.data.formattedCompareAtPrice;
    // this.debug ? debugger : '';
    if (formattedPrice||formattedCompareAtPrice) {
      this.updatePrices(formattedPrice,formattedCompareAtPrice);
    } else {
      this.updatePrices(variant.price,variant.compare_at_price);
    }
    // this.updateVariant(event.data.variantId);
  }
  handleVariantInputs() {
    // snippets use product_form_id = 'product-form-' | append: section.id
    this.querySelectorAll(
      `#product-form-${this.dataset.sectionId}`
    ).forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.addEventListener('change', (event) => { variantId = target.value;} );
    });
  }
  // { data: { event, target, selectedOptionValues } }
  // handleOptionValueChange(event) {
  //   this.debug ? debugger : '';
  // }
  updatePrices(price,compareAtPrice) {
    // this.debug ? debugger : '';
    // onsale: REGULAR price = compare price, SALE-price = price
    if (price) {
      this.priceElement.innerText = price;
    }
    if (compareAtPrice) {
      this.PriceCompareElement.innerText = compareAtPrice;
    } else {
      this.PriceCompareElement.innerText = ' ';
    }

  }
  /*updateVariant(variantId) {
    this.debug ? debugger : '';
    this.variantIdElement.value = variantId;
  }*/

  getSelectedVariant(variantId) {
    const variantsJSON = document.getElementById('stickyFormVariantsJSON')?.innerHTML;
    // const selectedVariant = document.querySelector('[data-variants]')?.innerHTML;
    //return !!variants ? JSON.parse(variants) : null;
    let variants = JSON.parse(variantsJSON);
    // this.debug ? debugger : '';
    // TODO !!! some variants may not exists as products in the ADMIN so there will be no corresponding variant data to match the ID the app emits??
    return variants.find(variant => variantId == variant.id);
    //return variants.filter( (variant) => variantId == variant.id);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.productFormBounds = entries[0].isIntersecting;
      if (this.debug) {
        console.log('this.productFormBounds', this.productFormBounds);
        console.log('entries[0].boundingClientRect.top', entries[0].boundingClientRect.top);
      }
      this.boundingClientRectTop = entries[0].boundingClientRect.top;
    }/*, { rootMargin: "-200px 0px 0px 0px" }*/);

    observer.observe(this.productStickyForm);
  }

  /*observerCallback(entries, observer) {
    this.debug ? debugger : '';
    this.productFormBounds = entries[0].isIntersecting;
    if (this.debug) {
      console.log('this.productFormBounds', this.productFormBounds);
    }
  };
  createObserver() {
    // let observer = new IntersectionObserver(this.observerCallback, this.intersectionObserverOptions);
    let observer = new IntersectionObserver(this.observerCallback);
    observer.observe(this.productStickyForm);
  }*/

  onScroll() {
    if (this.debug) {
      console.log('this.productFormBounds', this.productFormBounds);
      console.log('this.boundingClientRectTop', this.boundingClientRectTop);
    }
    // this.productFormBounds
    if (document.documentElement.scrollTop > 800) {
      if (!this.productFormBounds) {
        requestAnimationFrame(this.reveal.bind(this));
      }
    }
    // this.boundingClientRectTop < 200
    if (this.productFormBounds && document.documentElement.scrollTop < 800) {
      requestAnimationFrame(this.hide.bind(this));
    }
  }

  hide() {
    if(this.productStickyForm.classList.contains('product--sticky-form__active')) {
      this.productStickyForm.classList.remove('product--sticky-form__active');
      this.productStickyForm.classList.add('product--sticky-form__inactive');
    }
  }

  reveal() {
    if(this.productStickyForm.classList.contains('product--sticky-form__inactive')) {
      this.productStickyForm.classList.add('product--sticky-form__active');
      this.productStickyForm.classList.remove('product--sticky-form__inactive');
    }
  }
});

/*const kachingBundlesBlock = document.querySelector('kaching-bundles-block')
Event when variant is selected in the bundle deal
Event detail contains select deal quantity + Selected variantID

kachingBundlesBlock.addEventListener('variant-selected', (event) => {
  this.debug ? debugger : '';
  console.log('variant-selected', event.detail)
})*/
/*
if (variantOnSaleElement) {
  if (compareAtPrice) {
    this.priceElement.innerText = compareAtPrice;
  }
  if (price) {
    this.PriceCompareElement.innerText = price;
  } else {
    this.PriceCompareElement.innerText = ' ';
  }
} else {
  if (compareAtPrice) {
    this.PriceCompareElement.innerText = compareAtPrice;
  } else {
    this.PriceCompareElement.innerText = ' ';
  }
};
*/